import React from 'react'
import { useTranslation } from 'react-i18next'
import { DashboardWidget } from 'features/widget/types'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from 'hooks/useWidgetState'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import ErrorMessage from '../../../share/ErrorMessage'
import { languageNotSupported } from '../utils/languageNotSupportedChecker'
import { dataNotReturned } from '../utils/dataNotReturnedChecker'

const isAllLanguageNotSupportedOrNoDataReturned = (
  widgetData: DashboardWidget<AnnotatedMetricResult>
) => widgetData.data.every((entry) => languageNotSupported(entry) || dataNotReturned(entry))

const LanguageNotSupportedOrNoDataReturnedGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<AnnotatedMetricResult>(widgetId)
  const { t } = useTranslation()

  if (isAllLanguageNotSupportedOrNoDataReturned(widgetData)) {
    return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>
  }

  return children
}

export default LanguageNotSupportedOrNoDataReturnedGuard
